import React, { Component } from "react";
import { blackOrWhiteByContrast } from "utils/General";
import rgb from "hex-rgb";
import getValue from "utils/value-types/get-value/text";
import { Div } from "components/Base";
import { isEqual } from "lodash";
import * as R from "ramda";

class TextCellFormatter extends Component {
  shouldComponentUpdate(nextProps) {
    return !isEqual(this.props.value, nextProps.value);
  }

  render() {
    const value = getValue(this.props.value);
    const { valueColor, truncate = true } = this.props;
    let style = {
      lineHeight: "24px"
    };
    if (valueColor) {
      style = {
        ...style,
        background: valueColor,
        color: blackOrWhiteByContrast(...rgb(valueColor)),
        borderRadius: 4,
        fontWeight: 600,
        fontSize: 12,
        padding: "0 6px",
        lineHeight: "2em",
        marginRight: 4
      };
    }

    if (
      R.path(["dependentValues", "meta", "columnSettings", "alignRight"])(
        this.props
      )
    ) {
      style.textAlign = "right";
      style.width = "100%";
    }

    if (
      R.path(["dependentValues", "meta", "columnSettings", "bigText"])(
        this.props
      )
    ) {
      style.fontSize = "16px";
      style.fontWeight = "600";
    }

    return (
      <Div
        truncate={truncate}
        style={{ ...style, ...this.props.style }}
        title={value}
      >
        {value}
      </Div>
    );
  }
}

export default TextCellFormatter;
